import { isMobile } from 'react-device-detect';

const Footer = () => {
  return (
    <div>
      {isMobile ? (
        ''
      ) : (
        <p className="clearfix mb-0 small">
          <span className="float-md-start d-block d-md-inline-block mt-25">
            COPYRIGHT © {new Date().getFullYear()}{' '}
            <a href="#" target="_blank" rel="noopener noreferrer">
              MyManager
            </a>
            <span className="d-none d-sm-inline-block">, All rights Reserved</span>
          </span>
        </p>
      )}
    </div>
  );
};

export default Footer;
